import { Component, OnInit, OnDestroy } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import {PlaceholderVisibilityService} from '../../services/placeholder-visibility/placeholder-visibility.service';
import {UserService} from '../../services/user.service';
import {EventTrackerService} from '../../services/event-tracker/event-tracker.service';
import {TranslateService} from '@ngx-translate/core';
import {WebUtils} from '../../utils/web.utils';

@Component({
  selector: 'verify-new-account',
  templateUrl: './verify-new-account.component.html',
  styleUrls: ['./verify-new-account.component.scss']
})
export class VerifyNewAccountComponent implements OnInit, OnDestroy {
  public verifySuccess: boolean;
  public isVerifying = false;
  private token: string;
  constructor(private router: Router,
              private activatedRoute: ActivatedRoute,
              private translate: TranslateService,
              private userService: UserService,
              private eventTracker: EventTrackerService,
              private placeholderService: PlaceholderVisibilityService) { }

  ngOnInit() {
    WebUtils.loadHubspotChatWidget();

    this.isVerifying = true;
    this.activatedRoute.queryParams.subscribe(res => {
      this.token = res.token;
      this.onVerifyEmail(res.token);
    });
  }

  ngOnDestroy(): void {
    WebUtils.removeHubspotChatWidget();
  }

  private onVerifyEmail(token: string) {
    this.placeholderService.show('verifyEmailHolder');
    this.userService.verifyEmail(token).subscribe(res => {
      this.verifySuccess = true;
      this.isVerifying = false;
      this.placeholderService.hide('verifyEmailHolder');

      // Just `trackUserVerifyAccount` for the first time
      if (res.message !== 'already_verified') {
        this.eventTracker.trackUserVerifyAccount(res.data.user);
      }

      window.location.href = res.data.redirectUrl;
    }, (err) => {
      this.verifySuccess = false;
      this.isVerifying = false;
      this.placeholderService.hide('verifyEmailHolder');
      this.navigateToLoginWhenAlreadyVerified(err);
    });
  }

  get verifyMessage() {
    if (this.isVerifying) {
      return null;
    }
    return this.verifySuccess ? this.translate.instant('sign_up.verify_success') : this.translate.instant('sign_up.verify_error');
  }

  get verifyButton() {
    if (this.isVerifying) {
      return this.translate.instant('sign_up.verifying_btn');
    }
    return this.verifySuccess ? this.translate.instant('sign_up.verify_success_btn') : this.translate.instant('sign_up.verify_error_btn');
  }

  afterVerify() {
    if (this.verifySuccess) {
      return this.router.navigate(['login']);
    } else {
      this.onVerifyEmail(this.token);
    }
  }

  private navigateToLoginWhenAlreadyVerified(error: Error) {
    if (error instanceof HttpErrorResponse) {
      if (error.status === 400) {
        const message = error.error && error.error.message;

        if (message === 'already_verified') {
          this.router.navigateByUrl('/login');
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/auth/verify-new-account/verify-new-account.component.ts